import React from 'react';
import 'assets/styles/main.scss';
import { useUserThunkDispatch } from 'hooks';
import { userActions } from 'store/user';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import useAsyncFetch from 'hooks/async-fetch';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import PageLoader from 'components/Loaders/PageLoader';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { UserRole, UserStatus } from 'store/user/types/state.types';

const App = () => {
  const thunkUserDispatch = useUserThunkDispatch();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);
  const location = useLocation();

  useAsyncFetch({
    async asyncFunc() {
      await thunkUserDispatch(userActions.refreshToken());
    },
    immediate: true,
    disableRedirectOn401: true,
    errorHandler() {
      dispatch(userActions.setLoading(false));
    },
  });

  React.useEffect(() => {
    if (location.pathname === '/') {
      if (user.role === UserRole.Customer && user.status === UserStatus.Active) {
        navigate('services', { replace: true });
      }
      if (user.role === UserRole.Admin && user.status === UserStatus.Active && process.env.REACT_APP_MODE === 'DEV') {
        navigate('admin', { replace: true });
      }
    }
  }, [location, user]);

  React.useEffect(() => {
    if (user.token && user.role !== UserRole.Customer) {
      thunkUserDispatch(userActions.fetchProfile());
    }
  }, [user.token]);

  return (
    <HelmetProvider>
      <Helmet>
        <title>Pro-Data Panel</title>
        <meta name="description" data-react-helmet="true" content="Личный кабинет" />
      </Helmet>
      {user.loading && <PageLoader className="main-page-loader" />}
      {
       !user.loading && <Outlet />
      }
    </HelmetProvider>
  );
};

export default App;
